import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { isMobile } from '../../../core/helpers/isMobile';

import GameLogo from '../../../components/common/gameLogo';

const GameLogoWrapper = observer(() => {
  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 112 : 537,
        y: isMobile() ? 156 : 23,
      },
    };
  }, []);

  return <GameLogo containerConfig={containerConfig} />;
});
export default GameLogoWrapper;
